export const ngo_data=(id)=>`/v2/guest/ngos/${id}`;
export const programs=(id)=>`/v2/guest/services/${id}`
export const statistics=(id)=>`/v2/guest/statistics/${id}`;
